export default __webpack_public_path__ + "static/media/IT.617f66ea.svg";